module.exports = __webpack_public_path__ + "static/media/023-online-shopping.c52b90fc.svg";